/**
 * PrimeVue's own strings, in German.
 *
 * Only the keys the admin actually reaches are filled in; the rest keep
 * PrimeVue's English defaults and are never rendered, because the components
 * that use them are not on any screen here.
 */
export const germanLocale = {
  dayNames: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
  dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
  dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  monthNames: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],
  today: "Heute",
  clear: "Leeren",
  chooseYear: "Jahr wählen",
  chooseMonth: "Monat wählen",
  chooseDate: "Datum wählen",
  prevMonth: "Voriger Monat",
  nextMonth: "Nächster Monat",
  prevYear: "Voriges Jahr",
  nextYear: "Nächstes Jahr",
  // Monday, as everywhere in Switzerland.
  firstDayOfWeek: 1,
  dateFormat: "dd.mm.yy",
  weekHeader: "KW",
  showMonthAfterYear: false,
  am: "vorm.",
  pm: "nachm.",
  apply: "Anwenden",
  accept: "Ja",
  reject: "Nein",
  choose: "Auswählen",
  upload: "Hochladen",
  cancel: "Abbrechen",
  completed: "Fertig",
  pending: "Wartet",
  emptyMessage: "Keine Einträge",
  emptyFilterMessage: "Keine Treffer",
  emptySelectionMessage: "Nichts ausgewählt",
  emptySearchMessage: "Keine Treffer",
  fileChosenMessage: "{0} Datei(en)",
  noFileChosenMessage: "Keine Datei ausgewählt",
  aria: {
    close: "Schliessen",
    previousPageLabel: "Vorige Seite",
    nextPageLabel: "Nächste Seite",
    lastPageLabel: "Letzte Seite",
    firstPageLabel: "Erste Seite",
    pageLabel: "Seite {page}",
    selectRow: "Zeile auswählen",
    unselectRow: "Auswahl aufheben",
    rowsPerPageLabel: "Einträge pro Seite",
  },
};
